import {TicketTLOEditorData} from './../../state/TicketTLO/EditorData';
import {Reducer} from "redux";
import {Action, ActionType} from "../../actions";
import {TicketTimeLimitOverrideFormData} from '../../../integrated-client/models/';
import {shallowValidationCheck} from '../../../utils/ValidationUtils';

const updateEditorData: Reducer<TicketTLOEditorData> = (
  state: TicketTLOEditorData = new TicketTLOEditorData(),
  action: Action<ActionType, TicketTimeLimitOverrideFormData>
) => {
  switch (action.type) {
    case ActionType.TICKET_TLO_EDITOR_DATA_RESET:
      return new TicketTLOEditorData();
    case ActionType.TICKET_TLO_EDITOR_DATA_FETCHED:
      return { ...state, editorData: action.data };
    case ActionType.TICKET_TLO_EDITOR_DATA_COPIED:
      return { ...state, editorData: { ...action.data } };
    case ActionType.TICKET_TLO_EDITOR_DATA_UPDATED:
      return { ...state, editorData: { ...state.editorData, ...action.data } };
    case ActionType.TICKET_TLO_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.TICKET_TLO_EDITOR_DATA_VALIDATED:
      let isValid = shallowValidationCheck(action.data);
      return { ...state, validation: action.data, readyToSave: isValid };
    case ActionType.TICKET_TLO_EDITOR_DATA_SET_BRANDS_AND_MARKETS:
      return { ...state, editorData: { brandAndMarket: action.data } };
    default:
      return state;
  }
};

export default updateEditorData;
